import { render, staticRenderFns } from "./Story.vue?vue&type=template&id=8eabb0b4"
import script from "./Story.vue?vue&type=script&lang=js"
export * from "./Story.vue?vue&type=script&lang=js"
import style0 from "./Story.vue?vue&type=style&index=0&id=8eabb0b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports